import './OptinEditor.css';
import React from 'react';
import { Box } from 'grommet';
import { Col, Row } from 'antd';
import Quilview from '../../../../../Component/Quilview/Quilview';
import { Table } from 'grommet-icons';
import { SectionHeader } from '../PreferencePage.styled';

const OptInEditor = ({ label, onTextChange, optinMessage }) => {
  return (
    <div>
      {label && (
        <div>
          <Table style={{ height: '15px' }} color={'#007ade'} />
          <SectionHeader>{label}</SectionHeader>
        </div>
      )}
      <Box className="quilsec">
        <Row>
          <Col span={8} />
        </Row>
        <Quilview
          style={{ borderRadius: '13px' }}
          isSimpleEditor
          value={optinMessage}
          ontextchange={newContent => onTextChange(newContent)}
          hasImageSupport
        />
      </Box>
    </div>
  );
};

export default OptInEditor;
